module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _FlexModalWrapper = __webpack_require__(1);
	
	var _FlexModalWrapper2 = _interopRequireDefault(_FlexModalWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _FlexModalWrapper2.default;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(3);
	
	var _reactBodySubtree = __webpack_require__(4);
	
	var _reactBodySubtree2 = _interopRequireDefault(_reactBodySubtree);
	
	var _FlexModalWrapper = __webpack_require__(5);
	
	var _FlexModalWrapper2 = _interopRequireDefault(_FlexModalWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalWrapper = function (_React$Component) {
	  _inherits(ModalWrapper, _React$Component);
	
	  function ModalWrapper() {
	    _classCallCheck(this, ModalWrapper);
	
	    var _this = _possibleConstructorReturn(this, (ModalWrapper.__proto__ || Object.getPrototypeOf(ModalWrapper)).call(this));
	
	    _this.handleMouseClickOutside = _this.handleMouseClickOutside.bind(_this);
	    return _this;
	  }
	
	  _createClass(ModalWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!document) {
	        return;
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('mousedown', this.handleMouseClickOutside);
	      }
	      if (this.props.preventScrolling) {
	        this.previousOverflow = document.body.style.overflow;
	        document.body.style.overflow = 'hidden';
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!document) {
	        return;
	      }
	      document.removeEventListener('mousedown', this.handleMouseClickOutside);
	      if (this.props.preventScrolling) {
	        document.body.style.overflow = this.previousOverflow;
	      }
	    }
	  }, {
	    key: 'handleMouseClickOutside',
	    value: function handleMouseClickOutside(e) {
	      var rootNode = (0, _reactDom.findDOMNode)(this.refs.content);
	      if (rootNode.contains(e.target) || e.button !== 0) {
	        return;
	      }
	      e.stopPropagation();
	      this.props.closePortal();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          useOverlay = _props.useOverlay,
	          overlayClassName = _props.overlayClassName,
	          overlayStyle = _props.overlayStyle,
	          closeModal = _props.closePortal;
	
	      var modalwrapper = _react2.default.createElement(
	        'div',
	        { className: className ? _FlexModalWrapper2.default.flexModalWrapper + ' ' + className : _FlexModalWrapper2.default.flexModalWrapper, ref: 'content' },
	        _react2.default.Children.map(this.props.children, function (c) {
	          return _react2.default.cloneElement(c, { closeModal: closeModal });
	        })
	      );
	      var overlay = void 0;
	      if (useOverlay) {
	        if (overlayStyle) {
	          overlay = _react2.default.createElement(
	            'div',
	            { className: _FlexModalWrapper2.default.flexModalOverlay, style: overlayStyle },
	            modalwrapper
	          );
	        } else {
	          overlay = _react2.default.createElement(
	            'div',
	            { className: _FlexModalWrapper2.default.flexModalOverlay + ' ' + (overlayClassName || _FlexModalWrapper2.default.overlayStyle) },
	            modalwrapper
	          );
	        }
	      } else {
	        overlay = _react2.default.createElement(
	          'div',
	          { className: _FlexModalWrapper2.default.flexModalOverlay },
	          modalwrapper
	        );
	      }
	      return overlay;
	    }
	  }]);
	
	  return ModalWrapper;
	}(_react2.default.Component);
	
	ModalWrapper.propTypes = {
	  children: _react2.default.PropTypes.node.isRequired,
	  className: _react2.default.PropTypes.string,
	  useOverlay: _react2.default.PropTypes.bool,
	  overlayStyle: _react2.default.PropTypes.object,
	  overlayClassName: _react2.default.PropTypes.string,
	  closeOnOutsideClick: _react2.default.PropTypes.bool,
	  preventScrolling: _react2.default.PropTypes.bool,
	  // passed by Portal
	  closePortal: _react2.default.PropTypes.func
	};
	
	var FlexModalWrapper = function (_React$Component2) {
	  _inherits(FlexModalWrapper, _React$Component2);
	
	  function FlexModalWrapper() {
	    _classCallCheck(this, FlexModalWrapper);
	
	    return _possibleConstructorReturn(this, (FlexModalWrapper.__proto__ || Object.getPrototypeOf(FlexModalWrapper)).apply(this, arguments));
	  }
	
	  _createClass(FlexModalWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          other = _objectWithoutProperties(_props2, ['children']);
	
	      var closeOnOutsideClick = other.closeOnOutsideClick,
	          className = other.className,
	          useOverlay = other.useOverlay,
	          overlayStyle = other.overlayStyle,
	          overlayClassName = other.overlayClassName,
	          preventScrolling = other.preventScrolling,
	          portalOptions = _objectWithoutProperties(other, ['closeOnOutsideClick', 'className', 'useOverlay', 'overlayStyle', 'overlayClassName', 'preventScrolling']);
	
	      return _react2.default.createElement(
	        _reactBodySubtree2.default,
	        portalOptions,
	        _react2.default.createElement(
	          ModalWrapper,
	          _extends({
	            ref: function ref(_ref) {
	              return _this3.modal = _ref;
	            }
	          }, { closeOnOutsideClick: closeOnOutsideClick, className: className, useOverlay: useOverlay, overlayStyle: overlayStyle, overlayClassName: overlayClassName, preventScrolling: preventScrolling }),
	          children
	        )
	      );
	    }
	  }]);
	
	  return FlexModalWrapper;
	}(_react2.default.Component);
	
	FlexModalWrapper.propTypes = {
	  children: _react2.default.PropTypes.node.isRequired,
	  className: _react2.default.PropTypes.string,
	  useOverlay: _react2.default.PropTypes.bool,
	  overlayStyle: _react2.default.PropTypes.object,
	  overlayClassName: _react2.default.PropTypes.string,
	  // Portal props
	  isOpened: _react2.default.PropTypes.bool,
	  openByClickOn: _react2.default.PropTypes.element,
	  closeOnEsc: _react2.default.PropTypes.bool,
	  closeOnOutsideClick: _react2.default.PropTypes.bool,
	  preventScrolling: _react2.default.PropTypes.bool,
	  onClose: _react2.default.PropTypes.func
	};
	FlexModalWrapper.defaultProps = {
	  useOverlay: true,
	  preventScrolling: true
	};
	
	module.exports = FlexModalWrapper;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = require("react");

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = require("react-dom");

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = require("react-body-subtree");

/***/ },
/* 5 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flexModalWrapper":"FlexModalWrapper__flexModalWrapper___GQhOs","flexModalOverlay":"FlexModalWrapper__flexModalOverlay___72E20","overlayStyle":"FlexModalWrapper__overlayStyle___aqiN6"};

/***/ }
/******/ ]);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-modal-wrapper/dist/index.js
// module id = 1457
// module chunks = 63